import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { apisiseci } from "../../../../../api";
import { AxiosError } from "axios";

export function useAttendanceLocalDepartmentQueueServiceTimeDelete() {
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    return useMutation<
        void,
        AxiosError<{ detail: string }>,
        number
    >({
        mutationKey: ["attendance-local", "department", "queue", "service-time", "delete"],
        mutationFn: async (id: number) => {
            await apisiseci.delete(`/cms/tempo_servico_fila/${id}/`, {
                headers: { Authorization: `Bearer ${token}` }
            });
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ['attendance-local', 'department', 'queue', 'service-time', 'list']
            });
            toast.success("Tempo de serviço removido com sucesso!");
        },
        onError: (error) => {
            toast.error(
                error?.response?.data?.detail || "Algo deu errado, tente novamente!"
            );
            console.log(error);
        },
    });
}
